import { type UseQueryResult, useQuery } from 'react-query';
import { AwardAgreementDocumentImportService } from '../../services/wealthlane-award-services/services/AwardAgreementDocumentImportService';
import { Wealthlane_AwardService_Dtos_AwardDocumentDto_AwardDocumentDto } from '../../services/wealthlane-award-services';

const useGetAwardDocByAwardId = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_AwardDocumentDto_AwardDocumentDto[] | undefined,
  unknown
> => {
  const awardDocByAwardId = useQuery(['getAwardDocByAwardId', id], async () => {
    if (id) {
      return await handleRequest(
        AwardAgreementDocumentImportService.getApiAwardApiAppAwardAgreementDocumentImportAwardDocumentsForParticipantByAwardId(
          id
        )
      );
    }
  });

  return awardDocByAwardId;
};

export default useGetAwardDocByAwardId;
